// =============================================================================
// Field — the "label above a control" wrapper used by the filter bars in page
// headers. Four pages had grown their own identical copy of this; this is the
// one they all import.
//
// Densities:
//   default   roomy — the long-standing page-header spacing.
//   dense     the compact filter bar. Use it on grid pages, where every pixel
//             the header spends is a pixel taken off the rows below it.
//
// `hint` becomes a tooltip on the label. It is for the qualifier that used to be
// spelled out inline ("Months (prices apply to)") — keeping the label itself to
// one short word is most of what makes the dense bar fit on a single row.
// =============================================================================
import React from 'react';

const Field = ({ label, hint, dense = false, children }) => (
  <div className={`flex flex-col ${dense ? 'gap-0.5' : 'gap-1'}`}>
    <span
      className={`font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wide ${
        dense ? 'text-[10px] leading-none' : 'text-xs'
      }`}
      title={hint}
    >
      {label}
    </span>
    {children}
  </div>
);

export default Field;
